import React, { useEffect, useMemo } from 'react';
import { Box, ErrorMessage, Text } from '@common-fe/common-fe';

import {
  DestinationType,
  LockboxStatus,
  LockboxValidationError,
  lockboxValidationErrorTitle,
} from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

import CheckAddress from './CheckAddress';
import CheckForBenefitOf from './CheckForBenefitOf';

interface Props {
  currentLockboxStatus?: LockboxStatus;
}

const SendRemainderBack: React.FC<Props> = ({ currentLockboxStatus }) => {
  const { editableLockbox, validationErrors, setEditableLockbox } = useLockboxDetailsStore();

  const hasCheck = !!editableLockbox?.check;

  const errorType = useMemo(() => {
    return validationErrors?.find((error) => error === LockboxValidationError.CHECK_ADDRESS_REQUIRED) as LockboxValidationError | undefined;
  }, [validationErrors]);

  const errorText = useMemo(() => errorType ? lockboxValidationErrorTitle?.[errorType] : undefined, [errorType]);

  // Initialization and state clearing
  useEffect(() => {
    if (!hasCheck) {
      setEditableLockbox({ remainder: { destinationType: DestinationType.CHECK } });
    }
    return () => {
      setEditableLockbox({ remainder: undefined });
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasCheck]);

  return (
    <>
      <Box>
        <Box  margin={{ top: 'spacing12' }} direction="row" align="center">
          <Text color="textSecondary">
            Send check to
          </Text>
          {errorText && (
            <Box margin={{ left: 'spacing8' }}>
              <ErrorMessage errorText={errorText} errorStyle={{ fontWeight: 500 }} />
            </Box>
          )}
        </Box>
        <Box margin={{ top: 'spacing12' }}>
          <CheckAddress currentLockboxStatus={currentLockboxStatus} />
        </Box>

        <Text color="textSecondary" margin={{ top: 'spacing12' }}>
          For benefit of
        </Text>
        <Box margin={{ top: 'spacing12' }}>
          <CheckForBenefitOf />
        </Box>
      </Box>
    </>
  );
};

export default SendRemainderBack;
